import { ProfileInformation } from '@mindly/ui-components';
import React from 'react';
import { IonSkeletonText } from '@ionic/react';

const SubscriptionSkeleton = () => {
  return (
    <div>
      <ProfileInformation isLoading={true} />
      <IonSkeletonText
        animated
        style={{
          margin: '30px 0 10px 0',
          padding: '0',
          width: '100%',
          height: '30px',
          borderRadius: '6px',
        }}
      />
      <IonSkeletonText
        animated
        style={{
          margin: '0 0 10px 0',
          padding: '0',
          width: '100%',
          height: '30px',
          borderRadius: '6px',
        }}
      />
      <IonSkeletonText
        animated
        style={{
          margin: '0 0 35px 0',
          padding: '0',
          width: '100%',
          height: '30px',
          borderRadius: '6px',
        }}
      />
      <IonSkeletonText
        animated
        style={{
          margin: '0 0 30px 0',
          padding: '0',
          width: '100%',
          height: '43px',
          borderRadius: '6px',
        }}
      />
      <div style={{ display: 'flex', marginBottom: '30px', gap: '4px' }}>
        <IonSkeletonText
          animated
          style={{
            margin: '0',
            padding: '0',
            width: '27px',
            height: '28px',
            borderRadius: '6px',
          }}
        />
        <IonSkeletonText
          animated
          style={{
            margin: '0',
            padding: '0',
            width: '100%',
            height: '28px',
            borderRadius: '6px',
          }}
        />
      </div>
      <IonSkeletonText
        animated
        style={{
          margin: '0',
          padding: '0',
          width: '100%',
          height: '47px',
          borderRadius: '6px',
        }}
      />
    </div>
  );
};

export default SubscriptionSkeleton;
